import React from 'react';
import { Redirect } from 'react-router';

import routerStore from '@app/src/common/store/RouterStore';

const Home = () => <Redirect to={routerStore.firstRoutePath}/>;

export default Home;
